import { hasWindow } from "@litres/utils";
import { useRef, useEffect } from "react";

export const usePortal = (id: string): Element | null => {
  const rootElemRef = useRef<Element | null>(null);

  const getRootElem = (): Element | null => {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement("div");
    }
    return rootElemRef.current;
  };

  const createRootElement = (id: string): Element => {
    const rootContainer = document.createElement("div");
    rootContainer.setAttribute("id", id);
    return rootContainer;
  };

  const addRootElement = (rootElem: Element): void => {
    document.body.insertBefore(
      rootElem,
      document.body.lastElementChild?.nextElementSibling ||
        document.body.lastElementChild
    );
  };

  useEffect(() => {
    if (!hasWindow) {
      return;
    }

    const existingParent = document.querySelector(`#${id}`);
    const parentElem = existingParent || createRootElement(id);

    if (!existingParent) {
      addRootElement(parentElem);
    }

    if (rootElemRef.current) {
      parentElem.appendChild(rootElemRef.current);
    }

    return (): void => {
      if (rootElemRef.current) {
        rootElemRef.current.remove();
      }
    };
  }, [id]);

  if (!hasWindow) {
    return null;
  }

  return getRootElem();
};
